import { Expose } from '@nts/std/serialization';
import { ExternalLayoutMetaData } from './external-layout-meta-data';
import { ExternalGridFieldMetaDataInterface } from '@nts/std/interfaces';

export class ExternalGridFieldMetaData extends ExternalLayoutMetaData implements ExternalGridFieldMetaDataInterface {

  constructor() {
    super();
  }

  @Expose()
  isAutoSize: boolean;

  @Expose()
  width: number;
}
